import { Route } from "react-router";
import { MEAL, MEALS, MEAL_COPY, MEAL_EDIT, MEAL_NEW } from "@routes/routes";
import {
  MealHeaderLayout,
  MealCopyPage,
  MealEditPage,
  MealNewPage,
  MealPage,
  MealsPage,
} from "@routes/lazyPages";

/** Meals — list, preview, editor and copy. */
export const mealRoutes = (
  <>
    <Route lazy={MealHeaderLayout}>
      <Route path={MEAL} lazy={MealPage} />
    </Route>
    <Route path={MEALS} lazy={MealsPage} />
    <Route path={MEAL_NEW} lazy={MealNewPage} />
    <Route lazy={MealHeaderLayout}>
      <Route path={MEAL_EDIT} lazy={MealEditPage} />
      <Route path={MEAL_COPY} lazy={MealCopyPage} />
    </Route>
  </>
);
